import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppHeader from "@saleor/components/AppHeader";
import CardMenu from "@saleor/components/CardMenu";
import FilterBar from "@saleor/components/FilterBar";
import { sectionNames } from "@saleor/intl";
import { SubscriptionList_subscriptions_edges_node } from "@saleor/subscribers/types/SubscriptionList";
import { SubscriberListUrlSortField } from "@saleor/subscribers/urls";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Container from "../../../components/Container";
import PageHeader from "../../../components/PageHeader";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "../../../types";
import SubscriberList from "../SubscriberList";
import {
  createFilterStructure,
  SubscriberFilterKeys,
  SubscriberListFilterOpts
} from "./filters";

const useStyles = makeStyles(
  {
    cardMenu: {
      margin: "0px 24px"
    }
  },
  { name: "SubscriberListPage" }
);

export interface SubscriberListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<SubscriberFilterKeys, SubscriberListFilterOpts>,
    SortPage<SubscriberListUrlSortField>,
    TabPageProps {
  subscribers: SubscriptionList_subscriptions_edges_node[];
  onBack: () => void;
  onExport: () => void;
  toatlCount:number;
}

const SubscriberListPage: React.FC<SubscriberListPageProps> = ({
  currencySymbol,
  filterOpts,
  initialSearch,
  onAdd,
  onBack,
  onFilterChange,
  onSearchChange,
  currentTab,
  onAll,
  onExport,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();
  const classes = useStyles({});

  const structure = createFilterStructure(intl, filterOpts);

  return (
    <Container>
      <AppHeader onBack={onBack}>
        <FormattedMessage {...sectionNames.configuration} />
      </AppHeader>
      <PageHeader title={intl.formatMessage(sectionNames.subscribers)+"("+toatlCount+")"}>
        <CardMenu
          className={classes.cardMenu}
          menuItems={[
            {
              label: intl.formatMessage({
                defaultMessage: "Export Subscribers",
                description: "export subscribers to csv file, button"
              }),
              onSelect: onExport,
              testId: "export"
            }
          ]}
          data-test="menu"
        />
        <Button onClick={onAdd} color="primary" variant="contained">
          <FormattedMessage
            defaultMessage="Create Subscriber"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Subscribers",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Subscriber..."
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <SubscriberList {...listProps} />
      </Card>
    </Container>
  );
};
export default SubscriberListPage;
